import { useState } from 'react'
import Button from '@/components/button'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import AddVendorManually from './vendor-manually'
import AddProductManually from './product-manually'
import { Lock } from 'lucide-react'
import { toast } from 'react-toastify'
import { useRouter } from 'next/navigation'

interface AddManuallyProps {
  type: 'vendor' | 'product'
  plusButton?: boolean
  setFormData?: Function
  setSendInvite?: Function
  canAddManually?: boolean
}

const AddManually = ({ type, setFormData, plusButton = false, setSendInvite, canAddManually = true }: AddManuallyProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const router = useRouter()

  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
    setSendInvite(false)
  }

  return (
    <>
      {plusButton ? (
        <Button
          onClick={canAddManually ? openModal : () => {
            toast.info(
              type === 'vendor'
                ? 'Creating vendors is available on Professional plans. Upgrade to unlock!'
                : 'Creating products is available on Professional plans. Upgrade to unlock!',
              {
                onClick: () => router.push('/pricing')
              }
            )
          }}
          title={
            <div className="flex items-center gap-2 sm:px-6">
              {!canAddManually && <Lock size={16} className="text-white" />}
              <img
                src="/images/plus.svg"
                alt="plus"
                className="h-6 w-6 max-w-fit"
              />
              <span className="hidden sm:flex">
                {type === 'vendor' ? 'Add Vendor' : 'Create New Product'}
                {!canAddManually && <span className="ml-1 text-xs">(Locked)</span>}
              </span>
            </div>
          }
          className={`h-[50px] whitespace-nowrap rounded-full !px-[0.85rem] font-normal text-white sm:pl-0 bg-[#85C349] hover:bg-[#75B339] ${
            !canAddManually ? 'opacity-75 cursor-not-allowed' : ''
          }`}
        />
      ) : (
        <Button
          onClick={openModal}
          title="Add Manually"
          className="mt-2 w-full px-4 py-2 font-normal text-white"
        />
      )}

      <Dialog open={isOpen} onOpenChange={closeModal}>
        <DialogContent className="max-h-[90vh] w-full max-w-[626px] overflow-y-auto overflow-x-hidden bg-white py-4 px-2 font-inter text-black">
          <h2 className="mt-4 ml-5 text-2xl font-semibold">
            {type === 'vendor' ? 'Create Vendor Profile' : 'Add Product'}
          </h2>
          {type === 'vendor' ? (
            <AddVendorManually onCancel={closeModal} setFormData={setFormData} />
          ) : (
            <AddProductManually onCancel={closeModal} setFormData={setFormData} />
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default AddManually